import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { RootState } from 'src/config/rootStore';
import { AssessmentGreetingModal } from 'src/modules/assessments/components/AssessmentGreetingModal';
import { SetOfAssessments } from 'src/modules/assessments/components/SetOfAssessments';
import { FlowType } from 'src/modules/assessments/models/assessments';
import { hasValidWho5Score } from 'src/modules/assessments/selectors/assessmentsSelectors';
import { StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CPProgramWeek } from '../cpProgram/models/cpProgram';

interface Props
    extends StepButtonsProps,
        ReturnType<typeof mapStateToProps>,
        RouteComponentProps<{}, {}, { fromBack?: boolean }> {
    week: CPProgramWeek;
}

interface State {
    showGreetingModal: boolean;
}

class WellbeingCheckInStepContainer extends React.Component<Props, State> {
    public state: State = {
        showGreetingModal: true,
    };

    private closeGreetingModal = () =>
        this.setState({
            showGreetingModal: false,
        });

    private isFirstWeek = () => this.props.week.id === ProgramWeekEnum.WeekOne;

    private shouldSkipSurvey = (): boolean => {
        const { state } = this.props.history.location;

        if (!this.isFirstWeek() || !this.props.who5ScoreIsValid || (state && state.fromBack)) {
            return false;
        }

        return true;
    };

    public handleSubmit = () => {
        this.props.goToNextStep();
    };

    public render(): JSX.Element {
        const { week, goToNextStep } = this.props;

        if (this.shouldSkipSurvey()) {
            goToNextStep();
        }

        const isFirstWeek = this.isFirstWeek();

        return (
            <>
                {week.greetingModalContent && (
                    <AssessmentGreetingModal
                        visible={this.state.showGreetingModal}
                        onStartClick={this.closeGreetingModal}
                        content={week.greetingModalContent}
                        isFirstWeek={isFirstWeek}
                    />
                )}
                <SetOfAssessments
                    currentWeekForLegacyPrograms={week.weekNumber + 1}
                    onSubmit={goToNextStep}
                    flowType={FlowType.LEGACY_PROGRAM}
                    onlyWho5
                    hideEmploymentHealthQuestions
                />
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    who5ScoreIsValid: hasValidWho5Score(state),
});

export const WellbeingCheckInStep = withRouter(
    connect(mapStateToProps)(WellbeingCheckInStepContainer),
);
